/*
  mc-gallery-arrows — Pfeile im Hauptbild der PDP-Galerie.

  Baut KEINEN eigenen Slider und keine eigene Statusverwaltung. Die Pfeile
  rufen nur die Navigationsmethoden der vorhandenen Komponenten auf:

    unter 1024px  Die Bilderliste ist ein horizontaler Scroll-Container.
                  -> SliderComponent.setSlidePosition(). Deren scroll-Listener
                     aktualisiert danach Zaehler und feuert 'slideChanged',
                     worauf media-gallery.js das aktive Thumbnail setzt.

    ab 1024px     Nur das aktive Bild steht im Fluss, alle anderen sind per
                  CSS display:none (section-main-product.css, Regel
                  ".product--thumbnail_slider .product__media-item:not(.is-active)").
                  Es gibt also nichts zu scrollen.
                  -> MediaGallery.setActiveMedia(), also genau der Weg, den
                     auch ein Klick auf ein Thumbnail nimmt.

  Unterschieden wird nicht ueber eine Breite, sondern ueber die Frage, ob der
  Container ueberhaupt scrollbar ist. Damit bleibt das Verhalten richtig, falls
  der Umschaltpunkt noch einmal wandert.

  Die Galerie laeuft um: hinter dem letzten Bild kommt wieder das erste. Beim
  Umlaufen wird der Scroll-Container hart gesetzt (scroll-behavior kurz auf
  auto), sonst wischt die Ansicht sichtbar ueber alle Bilder zurueck.
*/
if (!customElements.get('mc-gallery-arrows')) {
  customElements.define(
    'mc-gallery-arrows',
    class McGalleryArrows extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.viewer = this.closest('slider-component');
        this.gallery = this.closest('media-gallery');
        if (!this.viewer) return;

        this.querySelectorAll('[data-mc-dir]').forEach((button) => {
          button.addEventListener('click', this.onButtonClick.bind(this));
        });

        // Pfeiltasten, sobald der Fokus irgendwo in der Galerie sitzt.
        this.viewer.addEventListener('keydown', this.onKeyDown.bind(this));
      }

      /* Alle Kacheln, die gerade wirklich Platz einnehmen. Auf dem Desktop ist
         das genau eine — dieselbe Filterung wie in SliderComponent.initPages(). */
      visibleItems() {
        return Array.from(this.viewer.querySelectorAll('.product__media-item')).filter(
          (element) => element.clientWidth > 0
        );
      }

      onKeyDown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        const target = event.target;
        if (target && target.matches('input, textarea, select')) return;
        event.preventDefault();
        this.go(event.key === 'ArrowRight' ? 1 : -1);
      }

      onButtonClick(event) {
        event.preventDefault();
        this.go(event.currentTarget.dataset.mcDir === 'next' ? 1 : -1);
      }

      go(direction) {
        const slider = this.viewer.slider;
        if (!slider) return;

        const scrollable = slider.scrollWidth - slider.clientWidth > 1;
        if (scrollable) {
          this.scrollTo(slider, direction);
        } else {
          this.switchActive(direction);
        }
      }

      /* Unter 1024px: an die Position der Nachbarkachel scrollen. */
      scrollTo(slider, direction) {
        const items = this.visibleItems();
        if (items.length < 2) return;

        const origin = items[0].offsetLeft;
        let current = 0;
        let smallest = Infinity;
        items.forEach((element, index) => {
          const distance = Math.abs(element.offsetLeft - origin - slider.scrollLeft);
          if (distance < smallest) {
            smallest = distance;
            current = index;
          }
        });

        const wraps = direction === 1 ? current === items.length - 1 : current === 0;
        const next = (current + direction + items.length) % items.length;
        const position = items[next].offsetLeft - origin;

        if (wraps) {
          // Sprung statt Wischen ueber die gesamte Reihe.
          const previous = slider.style.scrollBehavior;
          slider.style.scrollBehavior = 'auto';
          this.viewer.setSlidePosition(position);
          slider.style.scrollBehavior = previous;
          // scroll-behavior:auto loest den scroll-Listener der Komponente aus,
          // der Zaehler und 'slideChanged' nachzieht — kein Extraaufwand noetig.
        } else {
          this.viewer.setSlidePosition(position);
        }
      }

      /* Ab 1024px: aktives Medium umschalten, wie bei einem Thumbnail-Klick. */
      switchActive(direction) {
        if (!this.gallery || typeof this.gallery.setActiveMedia !== 'function') return;

        const items = Array.from(this.viewer.querySelectorAll('.product__media-item[data-media-id]'));
        if (items.length < 2) return;

        let current = items.findIndex((element) => element.classList.contains('is-active'));
        if (current < 0) current = 0;

        const next = items[(current + direction + items.length) % items.length];
        this.gallery.setActiveMedia(next.dataset.mediaId, false);
      }
    }
  );
}
